import type {AppState} from "../../../state/AppState";
import {FieldDataTypes, stringOperators} from "../FieldDataTypes";
import {FieldDataType} from "../../../../generated/api/base";
import {TypeInlineInput} from "../../../../ui/widgets/input/clicktoedit/datatypes/type/TypeInlineInput";
import {TypeInputV5} from "../../../../ui/5.0/details/datatypes/TypeInputV5";

export const configureType = (appState: AppState) => {
	FieldDataTypes.configure({
		id: FieldDataType.Type,
		title: "Type",
		operatorsArray: stringOperators,
		formatter: (value) => {
			return appState.actions.getTypeName(value);
		},
		inlineInput: TypeInlineInput,
		inputV5: TypeInputV5,
		system: true,
	});
};
